import { Component, Input, Signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NotificationOfEmergencyStageForm } from '../../forms/notification-of-emergency-stage.form';
import { CommonModule } from '@angular/common';
import { DatePickerComponent } from '../../../../../../../../common/date-picker/date-picker.component';
import {
  ExposedMapControlComponent
} from '../../../../../../../../common/exposed-map/exposed-map-control/exposed-map-control.component';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';
import { ParcelsCrudComponent } from '../../../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';
import { AlertComponent } from '../../../../../../../../common/alert/alert.component';
import {
  DictTownRoadItem, DictTownStreetItem,
  DictTownWithRoadsItem,
  DictTownWithStreetsItem
} from '../../../../../../../../services/dictionary.common.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { DictionaryCommonService } from '../../../../../../../../services/dictionary.common.service';

@Component({
  selector: 'app-notification-of-emergency-stage-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DatePickerComponent,
    ExposedMapControlComponent,
    ValidationErrorsComponent,
    ParcelsCrudComponent,
    NgxMaskDirective,
    AlertComponent
  ],
  templateUrl: './notification-of-emergency-stage-form.component.html'
})
export class NotificationOfEmergencyStageFormComponent {
  @Input()
  public label: string = '';

  @Input()
  public form: NotificationOfEmergencyStageForm | undefined;

  @Input()
  public canRemoveStage = true;

  public townWithStreetsList: Signal<DictTownWithStreetsItem[] | undefined> = toSignal(this.dictService.getTownWithStreetsList());

  public townWithRoadsList: Signal<DictTownWithRoadsItem[] | undefined> = toSignal(this.dictService.getTownWithRoadsList());

  public getRoadList(townName?: string | null): Array<DictTownRoadItem> {
    return this.townWithRoadsList()?.filter(v => v.name === townName).at(0)?.roads || [];
  }

  public getStreetList(townName?: string | null): Array<DictTownStreetItem> {
    return this.townWithStreetsList()?.filter(v => v.name === townName)?.at(0)?.streets || [];
  }

  constructor(private dictService: DictionaryCommonService) {
  }

  public roadNumberChange(roadNumber: string): void {
    const roadName = this.getRoadList(this.form?.city.value).filter(v => v.roadNumber === roadNumber).at(0)?.roadName || '';
    this.form?.roadName?.setValue(roadName);
  }
}
